export default "__VITE_ASSET__Hsb04fg$__"